import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';

const TableSearchDate = ({ onDateChange, label = '날짜 선택' }) => {
    const [selectedDate, setSelectedDate] = useState(new Date());

    const handleDateChange = (newDate) => {
        setSelectedDate(newDate);
        if (onDateChange) {
            onDateChange(newDate);
        }
    };

    useEffect(() => {
        if (onDateChange) {
            onDateChange(selectedDate);
        }
    }, [selectedDate, onDateChange]);

    return (
        <DatePicker
            label={label}
            value={selectedDate}
            onChange={handleDateChange}
            slotProps={{ textField: { size: 'small', sx: { width: '10rem' } } }}
        />
    );
};

export default TableSearchDate;
